import type { Filter } from '../../store';
import { getFilterReadiness } from './filters-query.utils';

const requestedLoaders = new WeakSet<() => void>();

export const requestFilterOptions = (filter: Filter) => {
  if (!('loadOptions' in filter) || !filter.loadOptions) return;
  if (getFilterReadiness(filter) === 'ready') return;
  if (requestedLoaders.has(filter.loadOptions)) return;
  requestedLoaders.add(filter.loadOptions);
  filter.loadOptions();
};
